﻿/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260429
*/
'use strict';

import { allSettled, getPromise} from './ctssJQuery.js';
import { appDebugMode, getAppToken} from './snSite.js';

const token = getAppToken();

const getMemberProfileResponseStatsAsync = async (params ={}) =>
    await getPromise({ url: `MemberProfiles/${token.CG}/Stats` });

const getMemberProfilesCountAsync = async (params = {}) =>
    await getPromise({ url: `MemberProfiles/${token.CG}/Count` });

const getMemberProfileQuestionsAsync = async (params = {}) =>
    await getPromise({ url: `MemberProfiles/${token.CG}/Questions` });

const getMemberProfileResponsesAsync = async (params = {}) =>
    await getPromise({ url: `MemberProfiles/${token.CG}/${params.mg}` });

export {
    getMemberProfilesCountAsync,
    getMemberProfileQuestionsAsync,
    getMemberProfileResponseStatsAsync,
    getMemberProfileResponsesAsync
}
